import { HeaderLogotype } from '@design/components/header-logotype/HeaderLogotype';
import { SearchInput } from '@design/components/search-input/SearchInput';
import { breakpoints } from '@design/design-tokens/breakpoints/breakpoints';
import { ColorScheme } from '@design/design-tokens/themes/theme-names';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  HeaderCategory,
  HeaderCategoryGroup,
} from './components/category-group/HeaderCategoryGroup';
import styles from './HeaderNavigation.module.scss';

export interface HeaderNavigationProps {
  activeKey?: string;
  categories: HeaderCategory[];
  categoriesOptions: HeaderCategory[];
  className?: string;
  colorScheme?: ColorScheme;
  disabledKeys?: string[];
  onLogoClick: () => void;
  onSearchClick: () => void;
}

export const HeaderNavigation = ({
  activeKey,
  categories,
  categoriesOptions,
  className,
  colorScheme,
  disabledKeys,
  onLogoClick,
  onSearchClick,
}: HeaderNavigationProps) => {
  const { t } = useTranslation('common');
  const mediaQuery = window.matchMedia(breakpoints.xlg);
  const [isLargeScreen, setIsLargeScreen] = useState(mediaQuery.matches);

  useEffect(() => {
    const handleChange = () => setIsLargeScreen(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return (
    <header
      className={`${styles.header} ${className ?? ''}`}
      data-testid="header-navigation"
    >
      <button className={styles.logoButton} onClick={onLogoClick}>
        <HeaderLogotype
          className={styles.styledLogotype}
          colorScheme={colorScheme}
        />
      </button>

      <div className={styles.categories}>
        <SearchInput
          onClick={onSearchClick}
          placeholder={
            isLargeScreen
              ? t('common:sideNavigation.searchPlaceholder')
              : t('common:sideNavigation.smallSearchPlaceholder')
          }
        />
        {categories.map(category => (
          <HeaderCategoryGroup
            key={category.id ?? category.title}
            category={category}
            activeKey={activeKey}
            disabledKeys={disabledKeys}
          />
        ))}
      </div>

      <div className={styles.categories}>
        {categoriesOptions.map(category => (
          <HeaderCategoryGroup
            key={category.id ?? category.title}
            category={category}
            activeKey={activeKey}
            disabledKeys={disabledKeys}
          />
        ))}
      </div>
    </header>
  );
};
